// extracted by mini-css-extract-plugin
export var addButton = "_65-d";
export var bullets = "_65-e";
export var compact = "_65-2";
export var container = "_65-j";
export var extendedWarrantyModal = "_65-f";
export var learn = "_65-l";
export var learnMore = "_65-g";
export var offeringOption = "_65-3";
export var offeringPrice = "_65-8";
export var offeringSubtitle = "_65-7";
export var offeringTitle = "_65-6";
export var offeringsContainer = "_65-0";
export var pdpTilesBackground = "_65-n";
export var plan = "_65-m";
export var regular = "_65-1";
export var remove = "_65-k";
export var seeDetailsIcon = "_65-i";
export var seeDetailsLink = "_65-h";
export var selectedOption = "_65-4";
export var shieldIcon = "_65-b";
export var shieldIconCompact = "_65-c";
export var subtitle = "_65-a";
export var title = "_65-9";
export var unselectedOption = "_65-5";